import {
  createContext,
  useContext,
  useMemo,
  useState,
} from "react";

const MessageContext = createContext(null);

export const useMessageContext = () => {
  const context = useContext(MessageContext);

  if (!context) {
    throw new Error(
      "useMessageContext doit être utilisé dans MessageProvider."
    );
  }

  return context;
};

export const MessageProvider = ({
  children,
}) => {
  const [
    activeConversationId,
    setActiveConversationId,
  ] = useState(null);

  const [
    newIncomingMessage,
    setNewIncomingMessage,
  ] = useState(null);

  const value = useMemo(
    () => ({
      activeConversationId,
      setActiveConversationId,
      newIncomingMessage,
      setNewIncomingMessage,
    }),
    [
      activeConversationId,
      newIncomingMessage,
    ]
  );

  return (
    <MessageContext.Provider value={value}>
      {children}
    </MessageContext.Provider>
  );
};